module.exports = __webpack_public_path__ + "img/shooting03.8b534f0e.jpg";